// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"0636eea6","236":"416e3c59","259":"ba8f40b1","646":"8e187a23","650":"f63e37e3","898":"1343211a","945":"e7239a3c"}[chunkId] + ".chunk.css";
};